import * as React from "react";
import type { SVGProps } from "react";
const SvgCommentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="comment_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 384a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 512 384zM810.667 85.333H213.333a128 128 0 0 0-128 128V640a128 128 0 0 0 128 128H707.84l157.867 158.293A42.667 42.667 0 0 0 896 938.667a35.84 35.84 0 0 0 16.213-3.414A42.667 42.667 0 0 0 938.667 896V213.333a128 128 0 0 0-128-128zm42.666 707.84-97.706-98.133a42.667 42.667 0 0 0-30.294-12.373h-512A42.667 42.667 0 0 1 170.667 640V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334a42.667 42.667 0 0 1 42.666 42.666v579.84zM341.333 384a42.667 42.667 0 1 0 0 85.333 42.667 42.667 0 0 0 0-85.333zm341.334 0a42.667 42.667 0 1 0 0 85.333 42.667 42.667 0 0 0 0-85.333z"
    />
  </svg>
);
export default SvgCommentIcon;
